import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getInstructorIdData } from "../../../lib/classview";
import { deleteIdData, addData } from "../../../lib/sessionschedule";
import { getInstructorIdData as getInstructorDataforStudents } from "../../../lib/sessionscheduleview";
// import { getInstructorStudentwithClass } from "../../../lib/instructorstudentview";
import { getDataforInstructorActiveStudent } from "../../../lib/classdetailview";
import { useAuth } from "../../../usercontext";
import { getCurrentDateInput, getCurrentTimeInput } from "../../../generalfunc";
import moment from "moment";

function getSessionStorageOrDefault(key, defaultValue) {
  const stored = sessionStorage.getItem(key);
  if (!stored) {
    return defaultValue;
  }
  return JSON.parse(stored);
}

export default function InstructorNewSchedule() {
  const [instructorId, setInstructorId] = useState();
  const [instructorStudent, setInstructorStudent] = useState([]);
  const [instructorClass, setInstructorClass] = useState([])
  const [selectedStudent, setSelectedStudent] = useState();
  const [instructorSchedule, setInstructorSchedule] = useState([]);
  const [selectedClass, setSelectedClass] = useState();
  const [period, setPeriod] = useState("OneDate");
  const { profile, setProfile } = useAuth();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [time, setTime] = useState();
  const [showEndDate, setShowEndDate] = useState(false);
  const [storagedClassId, setStoragedClassId] = useState(
    getSessionStorageOrDefault('classId', '')
  );


  const navigate = useNavigate();

    // get studentId from URL query parameters if exists
    const urlParams = new URLSearchParams(window.location.search);
    const studentId = urlParams.get("studentId");


  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      await deleteIdData(id);
      GetInstructorScheduleData();
    }
  };

  async function GetInstructorStudent() {
    const students = await getDataforInstructorActiveStudent(profile.id);
    if(students)
    {
    setInstructorStudent(students);

    if (studentId) {
      setSelectedStudent(studentId);
    } else {
      setSelectedStudent(students[0].studentId);
    }

    setSelectedClass(students[0].classId)
    //setInstructorId(students[0].instructorId)
    setInstructorId(profile.id)
  }

  }

  async function GetInstructorStudentData() {
   const clas = await getInstructorIdData(profile.id);
    setInstructorClass(clas);
    if (clas.length > 0) {
      setSelectedClass(clas[0].id);
      //GetInstructorScheduleData(clas[0].instructorId);
      setInstructorId(clas[0].instructorId)
    }
  }

  async function GetInstructorScheduleData(instId) {
    if(selectedStudent)
    {
      const sched = await getInstructorDataforStudents(profile.id,selectedStudent);
      setInstructorSchedule(sched);
    }
  }

  /*
 var dateArray = getDates(new Date(), (new Date()).addDays(30));
 for (let i = 0; i < dateArray.length; i ++ ) {
  //alert (dateArray[i]);
 }
 */

  useEffect(() => {
    if (period !== "OneDate") setShowEndDate(true);
    else setShowEndDate(false);
  }, [period]);

  useEffect(() => {
  if(instructorStudent.length > 0)
    setSelectedClass(instructorStudent.filter(std => std.studentId === selectedStudent)[0].classId);
//    setSelectedClass(students[0].classId)
    GetInstructorScheduleData();
  }, [selectedStudent]);

  function getDateRange() {
    var addday = 0;
    var jstr = "days";

    if (period === "EveryWeek") addday = 7;
    if (period === "EveryOtherWeek") addday = 14;
    if (period === "EveryMonth") {
      addday = 1;
      jstr = "months";
    }

    var dateArray = new Array();
    var currentDate = startDate;
    while (currentDate <= endDate) {
      dateArray.push(currentDate);
      currentDate = moment(currentDate).add(addday, jstr).format("YYYY-MM-DD");
    }
    return dateArray;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

/*
    const students = await getInstructorStudentwithClass(
      instructorId,
      selectedClass
    );

    */
    var recArray = new Array();

    if (period === "OneDate") {
      recArray.push({
        studentId: selectedStudent,
        classId:selectedClass,
        instructorId: instructorId,
        ldate: startDate,
        ltime: time,
      });
    } else {
      var dateArray = getDateRange();

      dateArray.map(async function (data) {

        recArray.push({
          studentId: selectedStudent,
          classId:selectedClass,
          instructorId: instructorId,
          ldate: data,
          ltime: time,
        });
      });
    }
    await addData(recArray);

    GetInstructorScheduleData();

    // if studentId is set, redirect to the instructor-studentschedule page with the studentId
    if (studentId) {
      navigate(`/instructor/instructor-studentschedule/${selectedStudent}`);
    }
  };

  useEffect(() => {
    setStartDate(getCurrentDateInput());
    setEndDate(getCurrentDateInput(7));
    setTime(getCurrentTimeInput());

    GetInstructorStudent();
    GetInstructorScheduleData();
  }, []);



  return (
    <div className="col-xl-12 col-md-12 mx-auto">
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-2">
          {/* <div className="checkout-form personal-address add-course-info"> */}
            <div className="personal-info-head mb-2">
              <h4>Instructor Schedule</h4>
              <p></p>
            </div>

            <form role="form" onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-3">
                  <div className="form-group">
                    <label className="form-control-label">Student</label>
                    <div className="select-container">
                    <select
                          value={selectedStudent}
                          onChange={(e) => setSelectedStudent(e.target.value)}
                          className="select-box"
                        >
                          {instructorStudent.map(function (data, ix) {
                            return (
                              <option key={ix} value={data.studentId}>
                                {data.studentName + " " + data.studentSurname}
                              </option>
                            );
                          })}
                        </select>
                      <div className="icon-container">
                        <i className="fa-solid fa-chevron-down"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form-group row">
                    <div className="col-6">
                      <label className="form-control-label">Date</label>
                      <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-6">
                      <label className="form-control-label">Time</label>
                      <input
                        type="time"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form-group">
                    <label className="form-control-label">Period</label>
                    <div className="select-container">
                      <select
                        value={period}
                        onChange={(e) => setPeriod(e.target.value)}
                        className="select-box"
                      >
                        <option value={"OneDate"}>One Date</option>
                        <option value={"EveryWeek"}>Every Week</option>
                        <option value={"EveryOtherWeek"}>
                          Every Other Week
                        </option>
                        <option value={"EveryMonth"}>Every Month</option>
                      </select>
                      <div className="icon-container">
                        <i className="fa-solid fa-chevron-down"></i>
                      </div>
                    </div>
                  </div>
                </div>
                {showEndDate ? (
                  <div className="col-lg-3">
                    <div className="form-group">
                      <label className="form-control-label">End Date</label>
                      <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="update-profile d-flex justify-content-end">
                  <button type="submit" className="btn btn-primary">
                    Add New Date
                  </button>
                </div>
              </div>
            </form>

            <hr className="mt-2" />
            <div className="comman-space pb-0">
              <div className="settings-referral-blk course-instruct-blk  table-responsive">
                {/* Instructor Users */}
                <table className="table table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Class</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {instructorSchedule
                      ? instructorSchedule.map(function (data) {
                        return (
                          <tr key={data.id}>
                            <td>{data.id}</td>
                            <td>{data.studentname}</td>
                            <td>{data.ldate}</td>
                            <td>{data.ltime.substring(0, 5)}</td>
                            <td>
                              <div className="profile-share">
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDelete(data.id)}
                                >
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                      : ""}
                  </tbody>
                </table>
                {/* Instructor List */}
              </div>
            </div>
          </div>
        {/* </div> */}
      </div>
    </div>
  );
}
